var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomLeftQuarterCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 89,
    viewBox: "0 0 62 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5222 110.556C59.5222 122.417 57.298 131.549 53.3645 138.605C49.4429 145.639 43.7355 150.768 36.4947 154.501C21.8677 162.043 1.13665 163.827 -23.1802 163.827C-46.7976 163.827 -65.1056 154.497 -77.5532 139.353C-90.0425 124.159 -96.7588 102.946 -96.7588 79.0644C-96.7588 55.194 -90.0518 36.1918 -77.6661 23.1708C-65.2967 10.1668 -46.9867 2.83694 -23.1802 2.83694C0.0685349 2.83694 20.7066 17.5551 35.6523 38.6548C50.5829 59.7331 59.5222 86.7819 59.5222 110.556Z",
    stroke: "url(#paint0_linear_1598_1948)",
    strokeWidth: 4.70903
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1598_1948",
    x1: -18.6183,
    y1: 0.482422,
    x2: -18.6183,
    y2: 166.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9752BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1259"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftQuarterCircle);
export default __webpack_public_path__ + "static/media/BottomLeftQuarterCircle.42003c76.svg";
export { ForwardRef as ReactComponent };